<template>
  <!--      14-1 医疗机构收藏教育机构查看列表 -->
  <div class="main-css">
    <!--    标题-->
    <div class="title-css">
      {{ $t("collection")+$t("educationalInstitution") }}
    </div>
    <div class="main-box">
      <el-button  type="primary" style="width: 200px" @click="deleteClick">- お気に入りから削除</el-button>
      <!-- table部分 -->
      <div class="table">
        <el-table
          @row-click="qaq"
          :data="tableData"
          width="98%"
           :height="tableHeight"
          @sort-change="changeTableSort"
          @selection-change="handleSelectionChange"
          v-loading="loading"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <!-- ----------------------機関番号---------------------- -->
          <el-table-column prop="educationId" label="機関番号"  width="110"  :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("educationId") }}</p>
              <el-input
                v-model="searchData1"
                size="mini"
                placeholder="Search"
                @change="FuzzyQuery"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.educationId }}
            </template>
          </el-table-column>
          <!-- ----------------------教育機関名---------------------- -->
          <el-table-column prop="educationName" label="教育機関名" 
                      width="150"     :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("educationalInstitution") }}</p>
              <el-input
                v-model="searchData2"
                size="mini"
                placeholder="Search"
                @change="FuzzyQuery"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.educationName }}
            </template>
          </el-table-column>
          <!-- ---------------------所在地-------------------- -->
          <el-table-column prop="address" label="所在地"
                          :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("location") }}</p>
              <el-input
                v-model="searchData3"
                size="mini"
                placeholder="Search"
                @change="FuzzyQuery"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.address }}
            </template>
          </el-table-column>

          <!-- ----------------------代表者---------------------- -->
          <el-table-column prop="legalPerson" label="代表者"
                          :show-overflow-tooltip="true">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("representativeName") }}</p>
              <el-input
                v-model="searchData4"
                size="mini"
                placeholder="Search"
                @change="FuzzyQuery"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.legalPerson }}
            </template>
          </el-table-column>
          <!-- -----------------------機関属性----------------------- -->
          <el-table-column prop="attributes" label="機関属性" min-width="100"
      >
            <template slot="header">
              <p>{{ $t("institutionalAttributes") }}</p>
              <el-dropdown @command="organAttributeClick">
                <span class="el-dropdown-link">
                  {{ AttributeName }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item,index) in medicalAttributesValue"
                                    :key="item.code" :command="item">
                    {{item.name}}
                  </el-dropdown-item>
                  <el-dropdown-item :command="null">
                    {{"ALL"}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>

            <template slot-scope="scope">
              {{language==="CN"?scope.row.attributes_dictText:scope.row.jpattributes_dictText}}
            </template>
          </el-table-column>
          <!-- ------------------------学生人数------------------------ -->
          <el-table-column
            prop="studentNumber"
            label="学生人数"
            :sortable="'custom'"
            min-width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header"slot-scope="scope">
              <p class="operate">     {{ $t("studentNumber") }}</p>

              <el-input
                size="mini"
                v-model="searchData5"
              />
            </template>
            <template slot-scope="scope">
              {{language==="CN"?scope.row.studentNumber_dictText:scope.row.jpstudentNumber_dictText}}
            </template>
          </el-table-column>
          <!-- ------------------------観覧回数------------------------ -->
          <el-table-column
            prop="browseNumber"
            label="観覧回数"
            :sortable="'custom'"
            min-width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope" >
              <p class="operate">     {{ $t("numberOfVisits") }}</p>

              <el-input
                size="mini"
                v-model="searchData6"
              />
            </template>
          </el-table-column>

        </el-table>
         <!-- 分页部分 -->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout=" prev, pager, next"
            :total="totalItem"
            :page-size="pageSize"
          >
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{pageSize}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
      </div>
     
    </div>
  </div>
</template>
<script>
  import {
    queryMedicalCollectioneducation,
    queryFuzzyMedicalCollectioneducation,
    deleteMedicalCollectionEducation, educationResumeInfoFuzzyQuery,
  } from "../../js/api"
import AES from "../../js/AES";
import axios from "axios";
export default {
  name: "medicalStaffManagement",
  components: {},
  data() {
    return {
      jorc:this.$i18n.locale,
      idList: [],
      inputData1: "", //搜索框input内容
      tableData: [
        {
          number: "H220763",
          educateName: "INC介護人材育成センター",
          location: "中国・大連",
          responsible: "張未来",
          organAttribute: "短期大学",
          numberOfStudents: "1760",
          numberOfReplies: "4907",
        },
      ],
      searchData1: "", //表格第一个搜索--機関番号
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      searchData5: "", //表格第5个搜索
      searchData6: "", //表格第6个搜索
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      loading: false, //table loading
      searchDataStart: "",
      totalItem:0,
      medicalAttributesValue:[],
      language:"",
      dataItem:"",
      AttributeName:"All",
      AttributeNameCode:"",//下拉code
      tableHeight: "",//表格高度
    };
  },
  created() {
    //获取当前语言的值
    this.language=window.localStorage.getItem('language')
    //获取数据字典语言值方法
    this.getLanguage()
    //获取机构下拉
    this.selectsex();
    this.queryMedicalCollectioneducationDTO();
    this.searchDataStart = this.$route.query.searchData;
    console.log(this.searchDataStart);
     this.getTableHeight();
  },
  mounted() {
    window.addEventListener('setItemEvent', this.languageChange, true)
     let _this = this;
    window.onresize = () => {
      if (_this.resizeFlag) {
        clearTimeout(_this.resizeFlag);
      }
      _this.resizeFlag = setTimeout(() => {
        _this.getTableHeight();
        _this.resizeFlag = null;
      }, 100);
    };
  },
  destroyed() {
    window.removeEventListener('setItemEvent', this.languageChange, true)
  },
  computed: {},
  methods: {
     //获取表格高度
    getTableHeight() {
      let tableH = 350; //距离页面下方的高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 200) {
        this.tableHeight = 200;
      } else {
        this.tableHeight = window.innerHeight - tableH;
      }
    },
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------")
      console.log(e)
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue
        that.getLanguage();
        that.selectsex();
        that.FuzzyQuery();
      }
    },
    selectsex(){
      var that=this;
      axios.get('/api/modules-parent/common/getDateItem',
        {
          params: {
            dataItem:this.dataItem
          },
          headers:{
            'content-type': 'application/x-www-form-urlencoded',
            "token":localStorage.getItem("token")
          }
        })
        .then(function (res) {
          if(res.data.code === "A0000"||res.data.code === "C0252"){
            console.log("--------获取数据字典接口数据caseStatusShow--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.medicalAttributesValue = aesFecInfo.data

            console.log(that.showStatusData);
          }else{
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    //获得语言
    getLanguage()
    {
      if(this.language==="CN")
      {
        this.dataItem="educationAttributes"
      }
      else
      {
        this.dataItem="jpeducationAttributes"
      }
      console.log("看我的数据字典数据"+this.dataItem)
    },
    //跳转页面
    qaq(row,event,column){
      console.log(row);
      this.$router.push({
        name: 'medicalViewEducationHomepage',
        params:{ educationId: row.educationId}
      });
      console.log(row);
    },
    //医疗机构取消收藏教育机构
    deleteClick() {
      console.log("- お気に入りから削除 button");
      if (this.idList.length < 1) {
        this.$message({
          message: "请选择至少一条信息!",
          type: "warning"
        });
      } else {
        const fakeInfo = {
          // "collectId": [],
          collectId: this.idList
        };
        deleteMedicalCollectionEducation(fakeInfo)
          .then(res => {
            console.log("-----医疗机构取消收藏教育机构-----");
            console.log(res);
            if (res.data.code === "A0000") {
              this.$message({
                message: "取消收藏成功!",
                type: "success"
              });
              this.queryMedicalCollectioneducationDTO();
            } else {
              this.$message.error("取消收藏失败");
            }
          })
          .catch(res => {
            console.log("-----医疗机构取消收藏教育机构-----");
            console.log(res);
          });
      }
    },
    //医疗机构收藏教育机构模糊查询
    FuzzyQuery(){
      var data = {
        address: this.searchData3,
        attributes: this.AttributeNameCode,
        educationId: this.searchData1,
        educationName: this.searchData2,
        legalPerson: this.searchData4,
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      }
      console.log(data)
      axios({
        method: "post",
        url: "/api/modules-parent/MedicalCollection/queryFuzzyMedicalCollectionEducation",
        data: data,
        headers: {
          "token":localStorage.getItem("token")
        }
      }).then(res => {
        console.log(res);
        if (res.data.code === "A0000") {
          // this.$message.error("查询成功");
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data))
          console.log(aesFecInfo)
          this.totalItem = aesFecInfo.total
          this.tableData = aesFecInfo.data
        }else if (res.data.code === 10001) {
       
          window.location.href="#/userFailure";
        } else {
          this.$message.error(res.data.message);
        }
        console.log(res.data);
      });
      //
      // queryFuzzyMedicalCollectioneducation(dto)
      //   .then((res) => {
      //     console.log("-----医疗机构收藏教育机构模糊查询-----");
      //     console.log(res);
      //     if( res.data.code == "A0000"){
      //       const aesFecInfo = JSON.parse(AES.decrypt(res.data.data))
      //       console.log(aesFecInfo)
      //       this.totalItem = aesFecInfo.total
      //       this.tableData = aesFecInfo.data
      //
      //     }else{
      //       this.$message.error('查询失败。');
      //     }
      //
      //   }).catch( (res) =>{} )
    },
    //医疗机构收藏教育机构查询
    queryMedicalCollectioneducationDTO(){
      var data = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
      };
      axios({
        method: "post",
        url: "/api/modules-parent/MedicalCollection/queryMedicalCollectionEducation",
        data: data,
        headers: {
          "token":localStorage.getItem("token")
        }
      }).then((res) => {
          console.log("--------医疗机构收藏教育机构查询--------");
          console.log(res);
          if( res.data.code == "A0000"){
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data))
            console.log(aesFecInfo)
            this.totalItem = aesFecInfo.total
            this.tableData = aesFecInfo.data

          }else if (res.data.code ===10001) {
       
          // this.$message.error("查询成功");
          window.location.href="#/userFailure";
        }else if (res.data.code ===10030) {
       
       // this.$message.error("查询成功");
       window.location.href="#/userApplying";
     } else{
            this.$message.error('查询失败。');
          }
        })
        .catch((res) => {
        });
    },
    //table排序
    changeTableSort(column){
      console.log(column);
      if (column.prop === "numberOfStudents") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["numberOfStudents"] - b["numberOfStudents"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["numberOfStudents"] - a["numberOfStudents"]
          );
        }
      } else {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["numberOfReplies"] - b["numberOfReplies"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["numberOfReplies"] - a["numberOfReplies"]
          );
        }
      }
    },
    //页码变化
    handleCurrentChange(evt) {

      console.log(evt);
      this.currentPage = evt;
      this.FuzzyQuery();
    },
    //每页条数下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
        console.log(this.pageSize);
      } else if (command === "b") {
        this.pageSize = 15;
        console.log(this.pageSize);
      } else if (command === "c") {
        this.pageSize = 20;
        console.log(this.pageSize);
      } else if (command === "d") {
        this.pageSize = 25;
        console.log(this.pageSize);
      }
      this.currentPage = 1;
      this.FuzzyQuery();
    },
    //机关属性筛选方法
    organAttributeClick(evt){
      if(evt === null){
        this.AttributeName = "All";
        this.AttributeNameCode = "";
      }else{
        this.AttributeName = evt.name;
        this.AttributeNameCode = evt.code;
      }
      this.FuzzyQuery();
      console.log(evt);
    },

    //选择行数据
    handleSelectionChange(val) {
      console.log(val);
      this.idList = [];
      for (var i = 0; i < val.length; i++) {
        this.idList.push(val[i].collectId);
      }
      this.stateChange = val;
    },

  },
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
}
.main-box {
  margin-top: 20px;
  width: 100%;
  height: 80%;
  padding: 0 40px 0 80px;
  box-sizing: border-box;
}
.title-background{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 14px 20px;

  position: absolute;
  left: 20%;
  right: 60%;
  top: 15%;
  bottom: 80.56%;

  background: #51abff;
  border-radius: 8px;
}
.title-background-test{
  background-color: transparent;
  border: none;
  position: static;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 34px;
}
.title-delete{
  position: static;
  width: 176px;
  height: 34px;
  left: 62px;
  top: 3px;

  /* 左侧按钮式样 */

  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 34px;
  /* identical to box height, or 189% */

  display: flex;
  align-items: center;
  text-align: center;

  /* Just White */

  color: #FFFFFF;


  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 10px;
}
.search {
  width: 100%;
  height: 25px;
  display: flex;
}
.search /deep/ .el-input__inner {
  width: 314px;
  height: 24px;
}
.search /deep/ .el-input {
  width: 314px;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
}
.search /deep/ .el-input__icon {
  line-height: 24px;
}
.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}
.table {
  margin-top: 20px;
  width: 98%;
}
.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
}
.table /deep/ .el-dropdown {
  width: 100px;
}
.el-dropdown-link {
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}
.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.table /deep/ .el-table__cell {
  position: relative;
}
 /* .table /deep/ .is-sortable> .cell {
   display: flex;
  } */
.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -5px;
  right:0;
  width: 67px;
}
.pagination {
  width: 100%;
  height: 50px;
  margin-top: 10px;
}
.pagination-main {
  float: right;
  display: flex;
}
.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}
.rowsPage-css {
  background: peru;
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}
.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}
.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}
.title-css {
  font-family: "lucida sans unicode", "lucida grande", sans-serif; /*字体*/
  color: #6b5656; /*字体颜色*/
  font-size: 2em; /*字体大小*/
  text-align: center; /*对齐方式*/
  line-height: 4; /*行间距*/
}
.el-table--border th.gutter:last-of-type{
  display: block!important; width: 17px!important;
}

</style>




// WEBPACK FOOTER //
// src/pages/medicalFavouritesEducationalInstitutionsViewList/index.vue